(function () {
    'use strict';

    // @ngInject
    Controllers.MobileCommentsController = function MobileCommentsController($modalInstance, $timeout, WorkspacesManager, workspaceFile) {

        this.workspaceFile = workspaceFile;
        this.WorkspacesManager = WorkspacesManager;
        this.workspaceModel =  this.WorkspacesManager.getWorkspace(this.workspaceFile.couple_card_id, true);



        this.ok = function ok() {
            $modalInstance.close();
        };

        this.cancel = function cancel() {
            $modalInstance.dismiss('cancel');
        };

        $timeout(function() {
            var el = angular.element('#js-submit-comment-textarea');
            if (el) {
                $timeout(function() {
                    el.focus();
                });
            }
        });

    };
}());